import AreasDetail from '../sections/areas-detail/AreasDetail';
import App from '../App';

window.App = App;
window.Section = AreasDetail;
